<template>

  <div class="row justify-content-end align-items-center col-12 mb-4 tablePagination">
    <div class="dropdown">
      <label class="mr-1">Page size</label>
      <button class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" id="dropdownMenu1">{{ pageSizeProp }}</button>
      <div class="dropdown-menu " aria-labelledby="dropdownMenu1">
        <span class="dropdown-item" v-on:click="$emit('setPageSize', 30)">30</span>
        <span class="dropdown-item" v-on:click="$emit('setPageSize', 50)">50</span>
        <span class="dropdown-item" v-on:click="$emit('setPageSize', 100)">100</span>
      </div>
    </div>
    <div class="d-md-none">
    </div>
    <div>
      <nav aria-label="Page navigation example" class="ml-1 ml-md-3">
        <ul class="pagination justify-content-end">
          <li class="page-item" :class="{ 'disabled' : currentPageIndex === 0 }">
            <span class="page-link" tabindex="-1" aria-disabled="true" aria-label="Previous" v-on:click="decCurrentPage()"></span>
          </li>
          <li v-for="(page, index) in pagesProp" :key="index" class="page-item" :class="{'active': currentPageIndex === index}">
            <span class="page-link" v-on:click="setCurrentPage(index)">{{ index + 1 }}</span>
          </li>
          <li class="page-item" :class="{ 'disabled' : currentPageIndex == (pagesProp.length - 1) }">
            <span class="page-link" aria-label="Next" v-on:click="incCurrentPage()"></span>
          </li>
        </ul>
      </nav>
    </div>
  </div>




</template>
<script>
import Flip from '../../utils/Flip';

export default {
  name: "TablesPaginationMenu",
  props: ["pagesProp", "pageSizeProp", "currentPageIndexProp"],
  data() {
    return {
      flip: new Flip()
    }
  },
  updated: function() {
    let newTables = Array.from(document.querySelectorAll('.tablePagination'));
    this.flip.play(newTables);
    this.flip = new Flip();
  },
  watch: {
    pagesProp(val, oldVal) {
      console.log(`[watch] [pagesProp] update ${(val && oldVal) ? '' : 'with missing value'}`);
      let existingTables = Array.from(document.querySelectorAll('.tablePagination'));
      this.flip.read(existingTables);
    }
  },
  computed: {
    currentPageIndex: function() {
     return this.currentPageIndexProp
    }
  },
  methods: {
    incCurrentPage: function () {
      console.log("[incCurrentPage] -~~-> setCurrentPageIndex");
      this.$emit('setCurrentPageIndex', this.currentPageIndex + 1)
    },
    setCurrentPage: function (val) {
      console.log("[setCurrentPage] -~~-> setCurrentPageIndex");
      this.$emit('setCurrentPageIndex', val)
    },
    decCurrentPage: function () {
      console.log("[decCurrentPage] -~~-> setCurrentPageIndex");
      this.$emit('setCurrentPageIndex', this.currentPageIndex - 1)
    }
  }
};
</script>
<style scoped>
</style>